import * as React from 'react'
import { memo } from 'react'
import { Link } from 'gatsby'
import { GatsbyImage } from 'gatsby-plugin-image'
import { slugify } from '../helpers/StringHelpers'
import IconLoaders from '../icons/IconLoaders'
import PropTypes from 'prop-types'
import { srcSizes } from '../common/gatsbyImageData'
import useCDNImage from '../hooks/useCDNImage'

const ProductImageComponent = ({
  image,
  product,
  sizes = '100vw',
  loading = 'lazy',
  imgStyle = { objectFit: 'contain' },
  mockSizes = srcSizes,
  onClick = null,
  extraClasses = ''
}) => {
  const finalImage = useCDNImage(image, product, mockSizes, sizes)
  if (!finalImage) return null
  let Component = onClick ? 'button' : 'div'
  return (
    <Component
      onClick={onClick}
      className={'w-full h-full aspect-square p-1 shrink-0 ' + (extraClasses || '')}
    >
      {/* {tags && <Tags product={product} tags={tags} />} */}
      <GatsbyImage
        alt={product?.title || image?.name || 'Product Image'}
        image={finalImage.gatsbyImageData}
        loading={loading}
        fetchPriority={loading === 'eager' ? 'high' : 'auto'}
        imgStyle={imgStyle}
        className="w-full h-full aspect-square"
      />
    </Component>
  )
}
ProductImageComponent.propTypes = {
  image: PropTypes.object,
  sizes: PropTypes.string,
  loading: PropTypes.oneOf(['eager', 'lazy']),
  onClick: PropTypes.func,
  product: PropTypes.shape({
    sku: PropTypes.string,
    title: PropTypes.string,
    productType: PropTypes.string,
  }),
  imgStyle: PropTypes.object,
  extraClasses: PropTypes.string,
  mockSizes: PropTypes.array,
}
const ProductImage = memo(ProductImageComponent)

ProductImage.propTypes = {
  image: PropTypes.object,
  sizes: PropTypes.string,
  loading: PropTypes.oneOf(['eager', 'lazy']),
  product: PropTypes.shape({
    sku: PropTypes.string,
    title: PropTypes.string,
    productType: PropTypes.string,
  }),
  imgStyle: PropTypes.object,
  mockSizes: PropTypes.array,
}

const CategoryImageComponent = ({
  sku,
  alt,
  normal,
  url,
  productType,
  className = null,
  sizes = '(min-width: 1536px) 25vw, (min-width: 1024px) 33vw, 50vw',
  onClick = null,
  imgStyle = { objectFit: 'contain' },
  loading = 'lazy',
}) => {
  const finalImage = useCDNImage(normal, { productType }, srcSizes, sizes)
  const image = finalImage ? (
    <GatsbyImage
      id={'product-collection-image-' + sku}
      alt={alt}
      className={className}
      image={finalImage.gatsbyImageData}
      sizes={sizes}
      onClick={onClick}
      imgStyle={imgStyle}
      loading={loading}
      fetchPriority={loading === 'eager' ? 'high' : 'auto'}
    />
  ) : (
    <IconLoaders type={productType} />
  )
  return url ? (
    <Link to={url} className={'relative w-full aspect-square'}>
      {image}
    </Link>
  ) : (
    <div className="relative w-full aspect-square">{image}</div>
  )
}

CategoryImageComponent.propTypes = {
  sku: PropTypes.string,
  title: PropTypes.string,
  alt: PropTypes.string,
  normal: PropTypes.object,
  url: PropTypes.string,
  productType: PropTypes.string,
  product: PropTypes.object,
  className: PropTypes.string,
  sizes: PropTypes.string,
  onClick: PropTypes.func,
  imgStyle: PropTypes.object,
  loading: PropTypes.oneOf(['eager', 'lazy']),
}
const CategoryImage = memo(CategoryImageComponent)
CategoryImage.propTypes = {
  sku: PropTypes.string,
  title: PropTypes.string,
  alt: PropTypes.string,
  normal: PropTypes.object,
  url: PropTypes.string,
  productType: PropTypes.string,
  sizes: PropTypes.string,
  className: PropTypes.string,
  onClick: PropTypes.func,
  imgStyle: PropTypes.object,
  loading: PropTypes.oneOf(['eager', 'lazy']),
}

export default CategoryImage
export { ProductImage, slugify }
